import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import { wtFormatRoundedValue } from 'src/helpers/commons/utils'
import numberToWords, { toWords } from 'number-to-words'
import { wtGetDateTimeFormat } from 'src/helpers/commons/moment'
import JsBarcode from 'jsbarcode'
import { FRONT_BASE_URL } from 'src/config/Request'
import { STATE_PROVINCE_NAMES } from 'src/models/sale-orders'
const SODIssuancePDF = (pdfData, options = {}) => {
  const {
    canViewReviewedBy = true,
    doc: providedDoc = null,
    append = false,
    openInNewTab = true,
    returnDoc = false,
  } = options
  const doc = providedDoc || new jsPDF()
  if (providedDoc && append) {
    doc.addPage()
  }
  console.log(pdfData)
  const saleOrder = pdfData?.sale_order || {}
  const party = saleOrder.party || {}
  const isRetailCustomer = Number(saleOrder.retail_customer) === 1
  const customerName = isRetailCustomer ? saleOrder.retail_customer_name : party.name
  const customerCnic = isRetailCustomer ? saleOrder.retail_customer_cnic : (party.ntn || party.cnic)
  const customerProvince = isRetailCustomer
    ? (STATE_PROVINCE_NAMES[saleOrder.state] || saleOrder.state)
    : party.state
  const phoneValue = party.phone_1
  const hasPhone =
    phoneValue !== null &&
    phoneValue !== undefined &&
    String(phoneValue).trim() !== '' &&
    String(phoneValue).trim() !== '0'
  // const logo = 'assets/wil-icon.png'
  let yPosition = 74.5
  const logoPath = pdfData ? pdfData.company.logo : ''
  const company = pdfData ? pdfData.company : null
  let logo = process.env.PUBLIC_URL + '/logos' + `/${logoPath}`
  const pageWidth = doc.internal.pageSize.width
  const billingAddress = party.billing_address || '-'
  const billingAddressLines = doc.splitTextToSize(billingAddress, 150)
  const billingAddressY = hasPhone ? 105.5 : 100
  const customerDetailRowCount = isRetailCustomer
    ? 3
    : (hasPhone ? 5 : 4) + billingAddressLines.length
  const addLogoToAllPages = () => {
    const pageCount = doc.internal.getNumberOfPages()
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')

      const pageWidth = doc.internal.pageSize.width
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold') //Header middle branch logo
      doc.addImage(logo, 'PNG', pageWidth - 200, 4, company.logo_width, company.logo_height)


      doc.setFontSize(14)
      doc.text('Material Outward Gatepass', pageWidth - 12, 10, { align: 'right' })
    }
  }

  addLogoToAllPages()

  if (Number(pdfData.status) !== 2) {
    const watermarkFontSize = 72
    doc.setTextColor(245, 170, 170) // Set the color of the watermark text
    doc.setFont('Helvetica', 'normal') //Header middle branch logo
    doc.setFontSize(watermarkFontSize)
    doc.text(140, 200, 'APPROVAL PENDING', null, 45, 'center')
  }

  ///////////////////////////////////////////// Left Side
  doc.setFontSize(10)

  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.text('Gate Pass:', 15, 40, { align: 'left' })
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(`${pdfData.id ? pdfData.id : ''}`, 35, 40, {
    align: 'left',
  })

  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.text('SOD:', 15, 45, { align: 'left' })
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(`${pdfData.sale_order ? pdfData.sale_order.code : ''}`, 25, 45, {
    align: 'left',
  })

  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.text('DO:', 15, 50, { align: 'left' })
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(`${pdfData.sale_order_delivery ? pdfData.sale_order_delivery.code : ''}`, 22, 50, {
    align: 'left',
  })

  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.text('Warehouse:', 15, 55, { align: 'left' })
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(`${pdfData.warehouse ? pdfData.warehouse.name : ''}`, 36, 55, {
    align: 'left',
  })
  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.text('Type:', 15, 60, { align: 'left' })
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(pdfData.auto_approved ? 'Auto Approved' : 'Manually Approved', 27, 60, {
    align: 'left',
  })
  ///////////////////////////////////////////// Right Side

  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.text('SOD Date:', pageWidth - 90, 45)
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(
    `${pdfData.sale_order ? pdfData.sale_order.sod_date : ''}`,
    pageWidth - 70,
    45,
  )

  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.text('DO Date:', pageWidth - 90, 50)
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(
    `${pdfData.sale_order_delivery ? pdfData.sale_order_delivery.delivery_date : ''}`,
    pageWidth - 73,
    50,
  )
  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.text('Issuance Date:', pageWidth - 90, 55)
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(
    `${pdfData.issuance_date ? pdfData.issuance_date : ''}`,
    pageWidth - 63,
    55,
  )
  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.text('Creation Date:', pageWidth - 90, 60)
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(
    `${pdfData.created_at ? wtGetDateTimeFormat(pdfData.created_at) : ''}`,
    pageWidth - 63,
    60,
  )
  doc.setFontSize(13)
  doc.setTextColor('#0202f7')
  doc.setFont('Helvetica', 'bold')
  doc.text('Customer Details:', pageWidth - 195, 72)





  const textWidth = 39
  doc.setLineWidth(0.2)
  doc.line(pageWidth - 195, 73, pageWidth - 195 + textWidth, 73)



  doc.setFontSize(10)
  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')

  doc.text('Name:', pageWidth - 195, 79.5, { align: 'left' })
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(`${customerName || '-'}`, pageWidth - 183, 79.5, {
    align: 'left',
  })


  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.text('NTN / CNIC:', pageWidth - 195, 85)
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(`${customerCnic || '-'}`, pageWidth - 172, 85)

  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.text('Province:', pageWidth - 195, 90)
  doc.setFont('Helvetica', 'normal')
  doc.setTextColor('#0202f7')
  doc.text(`${customerProvince || '-'}`, pageWidth - 172, 90)

  if (!isRetailCustomer) {
    doc.setTextColor('#000000')
    doc.setFont('Helvetica', 'bold')
    doc.text('Contact Person:', pageWidth - 195, 95)
    doc.setFont('Helvetica', 'normal')
    doc.setTextColor('#0202f7')
    doc.text(`${party.contact_person || '-'}`, pageWidth - 165, 95)

    if (hasPhone) {
      doc.setTextColor('#000000')
      doc.setFont('Helvetica', 'bold')
      doc.text('Phone:', pageWidth - 195, 100)
      doc.setFont('Helvetica', 'normal')
      doc.setTextColor('#0202f7')
      doc.text(`${phoneValue}`, pageWidth - 180, 100)

    }

    doc.setTextColor('#000000')
    doc.setFont('Helvetica', 'bold')
    doc.text('Billing Address:', pageWidth - 195, billingAddressY)
    doc.setFont('Helvetica', 'normal')
    doc.setTextColor('#0202f7')
    doc.text(billingAddressLines, pageWidth - 165, billingAddressY)
  }



  const Table1 = Array.from({ length: customerDetailRowCount }, () => [{ content: '' }])
  doc.autoTable({
    startY: yPosition,
    margin: { top: 20 },
    body: Table1, // Body rows for second table
    theme: 'plain',
    tableLineColor: '#000000',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    styles: {
      lineColor: '#ffffff',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
      cellPadding: { top: 0.8, right: 0.8, bottom: 0.8, left: 0.8 },
    },
    didDrawPage: function (data) { },
  })


  const Table2 = [
    [
      { content: 'Sr#', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Item Name', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Item Brand', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Qty', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Serial', styles: { fontStyle: 'bold', halign: 'center' } },
    ],
  ]

  const Table2Body = (pdfData?.sod_issuance_details || []).map((detail, index) => [
    { content: index + 1, styles: { halign: 'center' } },
    { content: detail.item_name || '-', styles: { halign: 'left' } },
    { content: detail.item_brand || '-', styles: { halign: 'center' } },
    { content: wtFormatRoundedValue(detail.qty, ""), styles: { halign: 'center' } },
    {
      content: (detail.item_serials || []).join(', ') || '-',
      styles: { halign: 'left', overflow: 'linebreak' } // Wrap text
    },
  ])

  const gapBetweenTable23 = 3
  const startYForTable23 = doc.autoTable.previous.finalY + gapBetweenTable23

  doc.autoTable({
    startY: startYForTable23,
    head: Table2,
    body: Table2Body,
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      font: 'helvetica',
      fontSize: 9,
      cellPadding: 2,
    },
    columnStyles: {
      0: { cellWidth: 'auto' }, // Sr#
      1: { cellWidth: 'auto' }, // Item Name
      2: { cellWidth: 'auto' }, // Item Brand
      3: { cellWidth: 'auto' }, // Qty
      4: { cellWidth: 'auto' }, // Serial gets the remaining width
    },
    didDrawCell: (data) => {
      if (data.column.index === 4) {
        data.cell.styles.fontSize = 8; // smaller font for serials if too long
      }
    },
  })



  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'bold')
  doc.setFontSize(10)
  const gapBetweenTable = 9
  const startYForTable = doc.autoTable.previous.finalY + gapBetweenTable
  const PreparedBy = 'Prepared By'
  const ReviewedBy = 'Reviewed By'
  const ApprovedBy = 'Approved By'
  const PreparedByValue = pdfData.created_by_id ? pdfData.created_by.name : ''
  const ReviewedByValue =
    canViewReviewedBy && pdfData.reviewed_by_id ? pdfData.reviewed_by.name : ''
  const ReviewedAtValue =
    !pdfData.auto_approved && canViewReviewedBy && pdfData.reviewed_at
      ? wtGetDateTimeFormat(pdfData.reviewed_at)
      : ''
  const ApprovedByValue = pdfData.approved_by_id ? pdfData.approved_by.name : ''
  // Coordinates for PreparedBy
  const infoX = 16
  const infoY = startYForTable + 9

  // Coordinates for ReviewedBy
  const centerInfoX = 80
  const centerInfoY = startYForTable + 9

  // Coordinates for ApprovedBy
  const rightInfoX = 145
  const rightInfoY = startYForTable + 9

  const centerText = (text, x, width) => {
    const textWidth =
      (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) / doc.internal.scaleFactor
    const adjustedX = x + (width - textWidth) / 2
    return adjustedX
  }

  doc.setFontSize(9)

  // Display PreparedByValue above the line
  const lineYAbovePreparedBy = infoY - 4
  doc.setTextColor('#0501ff')
  doc.text(PreparedByValue, centerText(PreparedByValue, infoX, 50), lineYAbovePreparedBy)

  // Draw a horizontal line above PreparedBy details
  const lineYAbovePreparedByDetails = infoY - 3
  doc.setLineWidth(0.4)
  doc.line(infoX - 0, lineYAbovePreparedByDetails, infoX + 50, lineYAbovePreparedByDetails)

  doc.setTextColor('#000000')
  doc.text(PreparedBy, centerText(PreparedBy, infoX, 50), infoY)

  // Display ReviewedByValue above the line
  const lineYAboveCenterInfo = centerInfoY - 4
  doc.setTextColor('#0501ff')
  doc.text(ReviewedByValue, centerText(ReviewedByValue, centerInfoX, 50), lineYAboveCenterInfo)

  // Draw a horizontal line above reviewed by details
  const lineYAboveCenterInfoDetails = centerInfoY - 3
  doc.setLineWidth(0.4)
  doc.line(
    centerInfoX - 0,
    lineYAboveCenterInfoDetails,
    centerInfoX + 50,
    lineYAboveCenterInfoDetails,
  )

  doc.setTextColor('#000000')
  doc.text(ReviewedBy, centerText(ReviewedBy, centerInfoX, 50), centerInfoY)
  if (ReviewedAtValue) {
    doc.setTextColor('#0501ff')
    doc.text(ReviewedAtValue, centerText(ReviewedAtValue, centerInfoX, 50), centerInfoY + 4)
  }

  // Display ApprovedByValue above the line
  const lineYAboveRightInfo = rightInfoY - 4
  doc.setTextColor('#0501ff')
  doc.text(ApprovedByValue, centerText(ApprovedByValue, rightInfoX, 50), lineYAboveRightInfo)

  // Draw a horizontal line above right side details
  const lineYAboveRightInfoDetails = rightInfoY - 3
  doc.setLineWidth(0.4)
  doc.line(rightInfoX - 0, lineYAboveRightInfoDetails, rightInfoX + 50, lineYAboveRightInfoDetails)

  doc.setTextColor('#000000')
  doc.text(ApprovedBy, centerText(ApprovedBy, rightInfoX, 50), rightInfoY)


  const gapBetweenNameTime = 12.9
  const startYForDateTime = doc.autoTable.previous.finalY + gapBetweenNameTime

  const CreatedAtValue = !pdfData.auto_approved
    ? wtGetDateTimeFormat(pdfData.created_at ? pdfData.created_at : '')
    : ''
  // const PostedAtValue = wtGetDateTimeFormat(pdfData.posted_at ? pdfData.posted_at : '')
  const ApprovedAtValue = !pdfData.auto_approved
    ? wtGetDateTimeFormat(pdfData.approved_at ? pdfData.approved_at : '')
    : ''

  // Coordinates for CreatedAt
  const infoX1 = 16
  const infoY1 = startYForDateTime + 12.9

  // Coordinates for ApprovedAt
  const rightInfoX1 = 145
  const rightInfoY1 = startYForDateTime + 12.9

  const centerText1 = (text, x, width) => {
    const textWidth =
      (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) / doc.internal.scaleFactor
    const adjustedX = x + (width - textWidth) / 2
    return adjustedX
  }

  doc.setFontSize(9)

  // Display CreatedAtValue above the line
  const lineYAboveCreatedAt = infoY1 - 4
  doc.setTextColor('#0501ff')
  doc.text(CreatedAtValue, centerText1(CreatedAtValue, infoX1, 50), lineYAboveCreatedAt)

  // Display ApprovedAtValue above the line
  const lineYAboveRightInfo1 = rightInfoY1 - 4
  doc.setTextColor('#0501ff')
  doc.text(ApprovedAtValue, centerText1(ApprovedAtValue, rightInfoX1, 50), lineYAboveRightInfo1)
  const gapAfterText = 10
  const startYForgapAfterText = doc.autoTable.previous.finalY + gapAfterText
  doc.setFontSize(10)
  doc.setTextColor('#000000')
  doc.setFont('Helvetica', 'normal')
  const printReport = 'This Material Outward Gatepass is printed through ERP at  '
  const currentTime = moment().format('YYYY-MM-DD HH:mm:ss')
  const textWidth1 =
    (doc.getStringUnitWidth(printReport) * doc.internal.getFontSize()) / doc.internal.scaleFactor
  const textWidth2 =
    (doc.getStringUnitWidth(currentTime) * doc.internal.getFontSize()) / doc.internal.scaleFactor
  const totalWidth = textWidth1 + textWidth2
  const startXForPrintReport = (pageWidth - totalWidth) / 2
  const startYForPrintReport = startYForgapAfterText + 30
  doc.text(printReport, startXForPrintReport, startYForPrintReport)
  doc.setFont('Helvetica', 'bold')
  doc.setTextColor('#0202f7')
  doc.text(currentTime, startXForPrintReport + textWidth1, startYForPrintReport)

  const addBarCode = (doc) => {
    const qrCodeSize = 44
    const qrCodeX = (pageWidth - qrCodeSize) / 2
    const qrCodeY = doc.autoTable.previous.finalY + 50
    const qrCodeText = FRONT_BASE_URL + 'saleorder#view:' + pdfData.id


    // Generate barcode
    const canvas = document.createElement('canvas')
    JsBarcode(canvas, `${pdfData.id}-${pdfData.sale_order.code}-${pdfData.sale_order_delivery.code}-${pdfData.company_id}`, {
      format: 'CODE128', // Specify the barcode format
      displayValue: true, // Display the value below the barcode
      fontSize: 32,
    })

    // Convert canvas to data URL
    const barcodeDataURL = canvas.toDataURL('image/png')

    // Add the barcode image to the PDF
    doc.addImage(barcodeDataURL, 'PNG', qrCodeX, qrCodeY, 50, 20) // Adjust position and size as needed
  }
  addBarCode(doc)

  const addFooter = (doc) => {
    const pageCount = doc.internal.getNumberOfPages()
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.setTextColor('black')
      doc.setFontSize(9)
      const lineHeight = 286
      const lineWidth = 182
      const lineX = 14
      const lineY = lineHeight
      doc.line(lineX, lineY, lineX + lineWidth, lineY)
      doc.text(`Page ${i} / ${pageCount}`, 190, 290, { align: 'right' })
    }
  }
  addFooter(doc)
  if (returnDoc) {
    return doc
  }

  if (openInNewTab) {
    const pdfUrl = doc.output('bloburl')
    window.open(pdfUrl, '_blank')
  }

  return doc

}

export default SODIssuancePDF
